// <div data-controller="campaign--lead">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "joinButton" ];
  static classes = [ "" ]
  static values = {
    joinUrl: String,
    getLeadUrl: String,
    afterJoinMessage: String,
    buttonJoinMessage: String,
    buttonJoinedMessage: String
  };

  get karrotBridgeController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("karrotBridgeController"), "components--karrot-bridge")
  }

  async join() {
    const response = await api.post(this.joinUrlValue, {}, this.karrotBridgeController.requestHeader)

    if (response.data.status) {
      alert(response.data.status.message);
    } else {
      this.karrotBridgeController.bridge.openToast({ toast: { body: this.afterJoinMessageValue } });
      this.toggleJoinButton(false)
    }
  }

  toggleJoinButton(enable) {
    if (enable) {
      this.joinButtonTarget.innerText = this.buttonJoinMessageValue;
      this.joinButtonTarget.disabled = false;
      this.joinButtonTarget.classList.remove("karrot-button-disabled");
    } else {
      this.joinButtonTarget.innerText = this.buttonJoinedMessageValue;
      this.joinButtonTarget.disabled = true;
      this.joinButtonTarget.classList.add("karrot-button-disabled");
    }
  }

  async checkLead() {
    const response = await api.get(this.getLeadUrlValue, {}, this.karrotBridgeController.requestHeader)

    if (response.data.status) {
      alert(response.data.status.message);
      this.karrotBridgeController.bridge.closeRouter();
    } else {
      this.toggleJoinButton(response.data["may_join?"])
    }
    this.karrotBridgeController.loadingCompleted();
  }

  connect() {

  }

  disconnect() {

  }
}